export const supporters = [
  'Falling Branch Brewery',
  'A Pivotal Shift',
  'The Arena Club in Bel Air',
  'Herr Foods',
  'Longwood Gardens',
  'Bagel Works of Bel Air',
  'Jarrettsville Creamery and Deli',
  'Screening Bean, LLC',
  'Last Call',
  'Ladew Topiary Gardens',
  "Goetze's Candy Company, Inc.",
  "Wegman's",
  'The Soul Lift',
  'Great Wolf Lodge Perryville',
  'The Mill of Bel Air',
  "Ewing's Septic Services",
  'Jurassic Golf and Arcade',
  'Jarrettsville Pharmacy',
];
